var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_vm._t("form"),_c('div',{staticClass:"action"},[_vm._t("action")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }